import { CognitoUserPool } from "amazon-cognito-identity-js";

// Producción /** NO TOCAR SI NO TIENE AUTORIZACIÓN **/
const poolData = {
    Region: process.env.REACT_APP_AWS_REGION,
    UserPoolId: process.env.REACT_APP_COGNITO_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID
}

// PRUEBAS EN LOCAL Y AMBIENTE
/*
const poolData = {
    Region: "us-east-1",
    UserPoolId: "",
    ClientId: ""
} */

export const userDataPool = new CognitoUserPool( poolData );